import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { performReloginIfAllowed, getPostAuthorizeParams, postAuthorizePostFhirForm } from './lib/authorize-utils';
import Loader from './Loader';
import sessionStorageUtil from './lib/session-storage-util';

export default function LoginCallbackError({ error }) {

  const [ errorState, setErrorState ] = useState(undefined);
  useEffect(() => {
    (async function () {
      // https://github.com/okta/okta-auth-js/tree/3d32a216afddee28425a1aaab0e3f655312a8806/lib/errors
      if ([ 'AuthApiError', 'OAuthError', 'AuthSdkError' ].includes(error.name)) {
        const authorizePostParamsObject = getPostAuthorizeParams();
        if (authorizePostParamsObject.state && Object.keys(authorizePostParamsObject.state).length > 0) {
          const authorizeToOktaUrl = sessionStorageUtil.getOriginalAuthUrl();
          return postAuthorizePostFhirForm({
            originalPostAuthorizationParams: JSON.parse(authorizePostParamsObject.state),
            authorizeToOktaUrl,
            isLoginCallBackError: true,
          });
        }
        try {
          const url = new URL(window.location.href);
          const stateSearchParam = url.searchParams.get('state');
          const state = stateSearchParam ? JSON.parse(stateSearchParam) : {};
          const performingRelogin = await performReloginIfAllowed({
            cause: error.name,
            message: error.message,
            originalRedirectUri: state?.originalRedirectUri,
          });
          if (!performingRelogin) {
            setErrorState(error);
          }
        } catch (e) {
          setErrorState(error);
        }
      } else {
        setErrorState(error);
      }
    })();
  }, []);

  useEffect(() => {
    if (errorState){
      throw (errorState);
    }
  }, [ errorState ]);

  return <Loader />;
}

LoginCallbackError.propTypes = {
  error: PropTypes.object,
};
